<template>

  <nav class="navbar navbar-expand-md fixed-top shadow-sm bg-white d-print-none">
    <div class="container">
      <router-link :to="{ name: 'Home' }" class="navbar-brand mr-2 text-primary">
        <img src="../../assets/eeas/img/eeas-logo@2x.png" alt="Goalkeeper Schoolmaster" height="32" class="me-2 me-md-3">
        <span class="font-weight-medium">Goalkeeper</span>
      </router-link>
      
      <button class="navbar-toggler" @click="isShowingMenu = !isShowingMenu">
        <span v-if="!isShowingMenu" class="material-icons-rounded">menu</span>
        <span v-else class="material-icons-rounded">close</span>
      </button>

      <div class="navbar-collapse justify-content-end" :class="{ 'inView' : !isShowingMenu }" id="navbarNav">
        <ul class="nav navbar-nav ml-auto my-2 my-lg-0 pt-4 pt-md-0 navbar-nav-scroll">
          <li class="nav-item">
            <router-link class="nav-link underlineLink" :class="$route.name == 'Home'? 'active':''" aria-current="page" :to="{ name: 'Home' }" @click="isShowingMenu = !isShowingMenu">
              Home
            </router-link>
          </li>
          <li class="nav-item">
            <router-link class="nav-link underlineLink" :class="$route.name == 'Search'? 'active':''" aria-current="page" :to="{ name: 'Search' }" @click="isShowingMenu = !isShowingMenu">
              Courses
            </router-link>
          </li>
          <!-- <li class="nav-item">
            <router-link class="nav-link" :class="$route.name == 'About'? 'active':''" aria-current="page" :to="{ name: 'Bookmarks' }">
              <span class="material-icons-rounded fs-16">bookmarks</span>
              <span class="d-md-none ms-2" >Bookmarks</span>
            </router-link>
          </li> -->
         <li class="nav-item">
            <router-link class="nav-link underlineLink" :class="$route.name == 'About-Goalkeeper' || $route.name == 'About-Schoolmaster' ? 'active':''" aria-current="page" :to="{ name: 'About-Goalkeeper' }">
              About
            </router-link>
          </li>
          <li class="nav-item">
            <a href="#" @click.prevent="visible = true"  class="nav-link underlineLink">Subscribe</a>
          </li>
          <li class="nav-item ">
            <span class="nav-link disabled d-none d-md-block">|</span>
            <hr class="d-md-none w-75 mx-auto">
          </li>
          <li class="nav-item">
            <a :href="registrarUrl" class="btn-text underlineLink me-3">Login</a>
          </li>

        </ul>
        
      </div>
    </div>
  </nav>

  <Dialog v-model:visible="visible" modal contentClass="subscribe-dialog" :style="{ width: '80vw' }">
    <template #header>&nbsp;</template>
    <Subscribe />
  </Dialog>

</template>

<!-- <script src="./EeasNavbar.ts"></script> -->

<script setup lang="ts">
import {computed, ref} from "vue"
import Subscribe from '../../views/subscription/Subscribe.vue'

const isShowingMenu = ref(false);
const visible = ref(false);

const registrarUrl = computed(() => localStorage.getItem('registrarUrl')  || "/registrar/web")

</script>

<style lang="scss" scoped>

.subscribe-dialog {
  background-color: red;
}


::v-deep(.p-menu .p-menu-start) {
  padding: 0.75rem 1rem;
}
::v-deep(.p-menu .p-menuitem) {
  font-size: 0.875rem;
}


.nav-item {
  margin: 0 0.5rem;
  .nav-link {
    font-size: 0.875rem;
    color: #6c757d;
    padding: 2px 0;
    &.active {
      color: #1976d2;
      cursor: default;
    }
  }
  &:hover .nav-link {
    color: #1976d2;
  }
}
@media screen and (min-width: 768px) {
  .navbar-expand-md .navbar-nav .nav-link {
    padding-right: 0;
    padding-left: 0;
  }
}

@media screen and (min-width: 992px) {
  .nav-item {
    margin: 0 1rem;
  }
}

.navbar-toggler {
  padding: 5px 0;
  border: none;
 
  &:focus {
    box-shadow: none;
  }
}

@media screen and (max-width: 769px) {
  .navbar-collapse {
    position: fixed;
    background-color: white;
    top: 47px;
    height: calc(100vh - 47px);
    max-height: calc(100vh - 47px);
    width: 101vw;
    margin-left: -1.25rem;
    margin-right: -1.75rem;
    transition: all .3s ease-in-out;
    transform: translateX(0%);
    ul {
      display: flex;
      flex-direction: column !important;
      li {
        display: block;
        padding: 1rem 0;
        text-align: center;
        .nav-link {
          font-size: 22px;
        }
      }
    }
    &.inView {
      transform: translateX(-110%);
    }
  }
  
}

</style>
